/* Bunico ürün sayfası davranışları (Aşama 2 · 2.5; plan: planlar/2026-09-28-asama-2-urun-sayfasi.md).
   - CTA metni: "Sepete ekle · {toplam}" (adet × varyant fiyatı), tükenmiş varyantta "Tükendi · Gelince haber ver",
     sepete eklenince "Sepete eklendi ✓" (yeşil, 3 sn). Tema updateBuyButtons() ile düğme metnini varyant değişiminde
     yeniden yazdığı için (Codex A2-R3) metin, temanın son yazımından sonra gelen krown:variant:change olayında ve adet
     değişiminde aynı fonksiyonla kurulur. Temanın düğme/form referanslarına dokunulmaz; yalnız metin ve bir sınıf.
   - Toplam biçimi snippets/bunico-price.liquid ile aynı kural (tr-TR binlik ayracı, kuruş varsa ",xx", ₺ sonda).
     Görüntülenen para birimi TRY değilse toplam yazılmaz (yanlış biçim riski yok).
   Metinler sayfadaki [data-bn-pdp-metin] JSON'undan (dil dosyası) gelir. */
(() => {
  if (window.BunicoPdp) return;

  const bicim = kurus => {
    const lira = String(Math.floor(kurus / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const k = kurus % 100;
    return lira + (k ? ',' + String(k).padStart(2, '0') : '') + ' ₺';
  };

  const baglan = sayfa => {
    if (!sayfa || sayfa.dataset.bnPdpBagli) return;
    const metinKaynagi = sayfa.querySelector('script[data-bn-pdp-metin]');
    const form = sayfa.querySelector('form[data-type="add-to-cart-form"]');
    const metinAlani = form && form.querySelector('[data-js-product-add-to-cart-text]');
    const dugme = form && form.querySelector('[data-js-product-add-to-cart]');
    if (!metinKaynagi || !metinAlani || !dugme) return;
    sayfa.dataset.bnPdpBagli = '1';
    const metin = JSON.parse(metinKaynagi.textContent);
    const adetAlani = () => form.querySelector('input[name="quantity"]');
    let eklendiZamanlayici = null;

    const varyant = () => {
      const veri = sayfa.querySelector('product-variants[data-main-product-variants] [data-js-variant-data]');
      try { return veri ? JSON.parse(veri.textContent) : null; } catch (e) { return null; }
    };

    const ctaGuncelle = () => {
      if (eklendiZamanlayici) { clearTimeout(eklendiZamanlayici); eklendiZamanlayici = null; }
      dugme.classList.remove('bn-eklendi');
      const v = varyant();
      if (!v) return; // seçilmemiş/mevcut olmayan kombinasyon: temanın metni kalır
      if (!v.available) { metinAlani.textContent = metin.tukendi; return; }
      const adet = Math.max(1, parseInt((adetAlani() || {}).value, 10) || 1);
      metinAlani.textContent = metin.para === 'TRY'
        ? metin.sepete_ekle.replace('%TOPLAM%', bicim(v.price * adet))
        : metin.sepete_ekle_duz;
    };

    // Varyant değişimi: tema metni yazdıktan sonra (krown:variant:change aynı işlemin sonunda gönderilir).
    document.addEventListener('krown:variant:change', e => {
      const pf = e.detail && e.detail.productForm;
      if (!pf || sayfa.contains(pf)) ctaGuncelle();
    });
    // Adet: +/- düğmeleri olay göndermeden değeri değiştiriyor; tıklama kabarcığı ve girişler dinlenir.
    const adetKutusu = form.querySelector('product-quantity');
    if (adetKutusu) {
      adetKutusu.addEventListener('click', () => ctaGuncelle());
      adetKutusu.addEventListener('input', () => ctaGuncelle());
      adetKutusu.addEventListener('change', () => ctaGuncelle());
    }
    // Sepete eklendi: temanın product-form olayı.
    const urunFormu = form.closest('product-form');
    if (urunFormu) {
      urunFormu.addEventListener('add-to-cart', () => {
        dugme.classList.add('bn-eklendi');
        metinAlani.textContent = metin.eklendi;
        if (eklendiZamanlayici) clearTimeout(eklendiZamanlayici);
        eklendiZamanlayici = setTimeout(ctaGuncelle, 3000);
      });
    }
    ctaGuncelle();
  };

  /* Bedenimi bul (2.7 · B.2 çok ölçülü; plan: planlar/2026-09-28-coklu-olcu-beden-bulucu.md §4). Cem: ürünün ölçü
     tablosundaki bütün köpek ölçüleri birlikte kullanılır. Bir ölçü için aday = alt ≤ değer ≤ üst olan bedenler (sınırlar
     dahil); öneri = bütün ölçülerin aday kümelerinin kesişimi.
     - Tek ortak aday → o beden. Birden çoksa hepsi söylenir, standart sıradaki büyüğü önerilir (Karar 4, yalnız ortak
       adaylar içinde).
     - Bir ölçü hiçbir bedene uymuyorsa 'uyumsuz'; her ölçü bir bedene uyuyor ama ortak beden yoksa 'celiski'. İkisinde de
       beden zorlanmaz.
     - Ölçü tipleri: 'aralik' [alt, üst]; 'tek' en yakın beden; 'en_az' köpeğin ölçüsü bedenin değerinden küçük olmamalı.
     - Boş ölçü varken sonuç yok ('eksik', eksik ölçüler adlandırılır); harf, 0, eksi → 'gecersiz'.
     - Uygun beden tükendiyse bu söylenir; stokta diye uygun olmayan başka beden önerilmez.
     Hesap ölçülerin elle mi kayıtlı profilden mi geldiğine bakmaz (plan §11): olculer = { kod: sayı }. */
  const SIRA = ['XXSmall', 'XSmall', 'Small', 'Medium', 'Large', 'XLarge', 'XXLarge'];
  const bedenOner = (tablo, olculer, stok) => {
    const tanim = tablo.olculer;
    const bedenler = stok.filter(b => tablo.bedenler[b.deger]);
    const eksik = [], gecersiz = [];
    tanim.forEach(m => {
      const v = olculer[m.kod];
      if (v === undefined || v === null || v === '') eksik.push(m.kod);
      else if (typeof v !== 'number' || !isFinite(v) || v <= 0) gecersiz.push(m.kod);
    });
    const bos = { beden: null, adaylar: [], eksikOlculer: eksik, gecersizOlculer: gecersiz, uyumsuzOlculer: [], dokum: [], tukendi: false };
    if (gecersiz.length) return { ...bos, durum: 'gecersiz' };
    if (eksik.length) return { ...bos, durum: 'eksik' };
    const dokum = tanim.map(m => {
      const x = olculer[m.kod];
      let uyan;
      if (m.tip === 'en_az') {
        // Alt sınırlı tek değer (Cem 14 Ekim, can yeleğinde sırt): köpeğin ölçüsü bedenin değerine eşit ya da büyükse uyar
        // (sırt 20 olan bedene 26 cm köpek uyar); yalnız küçükse uymaz.
        uyan = bedenler.filter(b => x >= Number(tablo.bedenler[b.deger][m.kod]) - 1e-9);
      } else if (m.tip === 'tek') {
        // Tek sayılı ölçü (Cem B-Q1, 30 Eylül): en yakın beden(ler); eşit uzaklıkta (tam ortada) ikisi de aday.
        // Dış sınır (Cem D17-1, 30 Eylül): en küçük/en büyük referansın dışında komşu iki referans arasındaki farkın
        // yarısı kadar pay (sınır dahil); daha uzak değer hiçbir bedene uymaz ('uyumsuz'). Tek referanslı tabloda sınır yok.
        const ref = b => Number(tablo.bedenler[b.deger][m.kod]);
        const mesafe = b => Math.abs(ref(b) - x);
        const degerler = [...new Set(bedenler.map(ref))].sort((a, b) => a - b);
        const n = degerler.length;
        // Sınır dahil; kayan nokta payı 1e-9 (Codex D18-1: 6,35 + 0,325 = 6,674999… iken 6,675 girişi dışarıda sayılıyordu). Aday eşitliğiyle aynı pay.
        const disinda = n > 1 && (x < degerler[0] - (degerler[1] - degerler[0]) / 2 - 1e-9 || x > degerler[n - 1] + (degerler[n - 1] - degerler[n - 2]) / 2 + 1e-9);
        const enAz = Math.min(...bedenler.map(mesafe));
        uyan = disinda ? [] : bedenler.filter(b => Math.abs(mesafe(b) - enAz) < 1e-9);
      } else {
        uyan = bedenler.filter(b => { const a = tablo.bedenler[b.deger][m.kod]; return a[0] <= x && x <= a[1]; });
      }
      return { kod: m.kod, ad: m.ad, birim: m.birim, tip: m.tip, deger: x, adaylar: uyan.map(b => b.deger) };
    });
    const uyumsuz = dokum.filter(d => !d.adaylar.length).map(d => d.kod);
    if (uyumsuz.length) return { ...bos, durum: 'uyumsuz', uyumsuzOlculer: uyumsuz, dokum };
    const adaylar = bedenler.filter(b => dokum.every(d => d.adaylar.includes(b.deger)));
    if (!adaylar.length) return { ...bos, durum: 'celiski', dokum };
    const sira = b => { const i = SIRA.indexOf(b.deger); return i >= 0 ? i : 100 + bedenler.indexOf(b); };
    const beden = adaylar.reduce((a, b) => (sira(b) > sira(a) ? b : a));
    // B-Q11 (Cem): tercih edilen beden tükenmiş, ölçülere uyan başka aday stoktaysa söylenir; uymayan beden önerilmez.
    const stoktaAlternatif = beden.stok ? [] : adaylar.filter(b => b !== beden && b.stok);
    return { ...bos, durum: 'oneri', beden, adaylar, dokum, tukendi: !beden.stok, stoktaAlternatif };
  };
  const olcuOku = metin => {
    const t = String(metin || '').trim().replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(t)) return null;
    const n = Number(t);
    return n > 0 ? n : null;
  };
  const sayi = n => String(n).replace('.', ',');

  const bulucuBagla = sayfa => {
    const panel = sayfa.querySelector('[data-bn-bulucu]');
    const ac = sayfa.querySelector('[data-bn-bulucu-ac]');
    if (!panel || !ac || panel.dataset.bnBagli) return;
    let metin, tablo;
    try {
      metin = JSON.parse(panel.querySelector('[data-bn-bulucu-metin]').textContent);
      tablo = JSON.parse(panel.querySelector('[data-bn-bulucu-tablo]').textContent);
    } catch (e) { return; }
    panel.dataset.bnBagli = '1';
    const girdiler = [...panel.querySelectorAll('[data-bn-bulucu-girdi]')];
    const sonuc = panel.querySelector('[data-bn-bulucu-sonuc]');
    const dokumAlani = panel.querySelector('[data-bn-bulucu-dokum]');
    const sec = panel.querySelector('[data-bn-bulucu-sec]');
    const kart = panel.querySelector('[data-bn-bulucu-kart]');
    const kartBeden = panel.querySelector('[data-bn-bulucu-beden]');
    const kartTukendi = panel.querySelector('[data-bn-bulucu-tukendi]');
    const kartAralik = panel.querySelector('[data-bn-bulucu-aralik]');
    let secilecek = null;
    const stok = () => { try { return JSON.parse(panel.querySelector('[data-bn-bulucu-veri]').textContent); } catch (e) { return []; } };
    const dil = document.documentElement.lang || 'tr';
    const kisa = (liste, deger) => (liste.find(b => b.deger === deger) || { kisa: deger }).kisa;
    const bagla = p => (p.length > 1 ? p.slice(0, -1).join(', ') + ' ' + metin.ve + ' ' + p[p.length - 1] : p.join(''));
    const yardim = () => {
      const a = document.createElement('a');
      a.href = metin.iletisim_url; a.textContent = metin.iletisim;
      sonuc.append(' ' + metin.yardim + ' ', a, '.');
    };

    const temizle = () => {
      secilecek = null; sec.hidden = true; sonuc.textContent = ''; dokumAlani.textContent = '';
      kart.hidden = true; kartBeden.textContent = ''; kartAralik.textContent = ''; kartTukendi.hidden = true;
      girdiler.forEach(g => g.removeAttribute('aria-invalid'));
    };
    const hesapla = () => {
      temizle();
      const olculer = {};
      let dolu = 0;
      girdiler.forEach(g => {
        if (!g.value.trim()) return;
        dolu++;
        const n = olcuOku(g.value);
        olculer[g.dataset.bnBulucuGirdi] = n === null ? NaN : n;
      });
      if (!dolu) return;
      const liste = stok();
      const r = bedenOner(tablo, olculer, liste);
      const ad = kod => (tablo.olculer.find(m => m.kod === kod) || { ad: kod }).ad;
      if (r.durum === 'gecersiz') {
        girdiler.forEach(g => { if (r.gecersizOlculer.includes(g.dataset.bnBulucuGirdi)) g.setAttribute('aria-invalid', 'true'); });
        sonuc.textContent = metin.gecersiz;
        return;
      }
      if (r.durum === 'eksik') {
        sonuc.textContent = metin.eksik.replace('%OLCULER%', bagla(r.eksikOlculer.map(k => ad(k).toLocaleLowerCase(dil))));
        return;
      }
      const dokumMetni = d => `${d.ad} ${sayi(d.deger)} ${d.birim} → ${d.adaylar.map(x => kisa(liste, x)).join(', ')}`;
      if (r.durum === 'uyumsuz') {
        const aralik = kod => liste.filter(b => tablo.bedenler[b.deger])
          .map(b => { const a = tablo.bedenler[b.deger][kod]; return `${b.kisa} ${Array.isArray(a) ? sayi(a[0]) + '–' + sayi(a[1]) : sayi(a)}`; }).join(' · '); // tek sayılı ölçüde tek değer
        sonuc.textContent = r.dokum.filter(d => !d.adaylar.length)
          .map(d => metin.uyumsuz.replace('%OLCU%', `${d.ad} ${sayi(d.deger)} ${d.birim}`).replace('%ARALIK%', aralik(d.kod))).join(' ');
        yardim();
        return;
      }
      if (r.durum === 'celiski') {
        sonuc.textContent = metin.celiski.replace('%DOKUM%', r.dokum.map(dokumMetni).join(' · '));
        yardim();
        return;
      }
      // Öneri kartı (Cem, 14 Ekim): büyük beden + önerilen bedenin tablodaki ölçü aralıkları; tükendi/çoklu notu altta.
      kartBeden.textContent = r.beden.kisa;
      kartTukendi.hidden = !r.tukendi;
      const satir = tablo.bedenler[r.beden.deger] || {};
      kartAralik.textContent = tablo.olculer.map(m => {
        const a = satir[m.kod];
        if (a == null) return '';
        return `${m.ad} ${Array.isArray(a) ? sayi(a[0]) + '–' + sayi(a[1]) : sayi(a)} ${m.birim}`;
      }).filter(Boolean).join('\n');
      const satirlar = [];
      if (r.tukendi && r.stoktaAlternatif.length) satirlar.push(metin.alternatif.replace('%BEDEN%', r.beden.kisa).replace('%DIGER%', bagla(r.stoktaAlternatif.map(b => b.kisa))));
      else if (r.adaylar.length > 1) satirlar.push(metin.coklu.replace('%BEDENLER%', bagla(r.adaylar.map(b => b.kisa))));
      dokumAlani.textContent = satirlar.join('\n');
      kart.hidden = false;
      secilecek = r.beden; sec.hidden = false;
    };

    ac.addEventListener('click', () => {
      const acik = panel.hidden;
      panel.hidden = !acik;
      ac.setAttribute('aria-expanded', String(acik));
      if (acik) { hesapla(); girdiler[0].focus(); }
    });
    girdiler.forEach(g => g.addEventListener('input', hesapla));
    // Varyant değişince (renk: stok değişir; beden elle değişir) önceki sonuç silinir; alanlar doluysa güncel stokla yeniden
    // hesaplanır (tema data-update-block'ları krown:variant:change'ten önce yeniler).
    document.addEventListener('krown:variant:change', e => {
      const pf = e.detail && e.detail.productForm;
      if (pf && !sayfa.contains(pf)) return;
      hesapla();
    });
    sec.addEventListener('click', () => {
      if (!secilecek) return;
      const kutu = sayfa.querySelector('product-variants[data-main-product-variants] .bn-variant--size[data-js-product-variant]');
      const input = kutu && [...kutu.querySelectorAll('input[type=radio]')].find(x => x.value === secilecek.deger);
      if (input) {
        if (!input.checked) (kutu.querySelector('label[for="' + input.id + '"]') || input).click();
        input.focus();
      }
      panel.hidden = true;
      ac.setAttribute('aria-expanded', 'false');
    });

    /* A10 köpek profili (plan Görev 10.3; D40-R4/R8). Kayıt yalnız girişli müşterinin kendi sayfasında JSON olarak gelir.
       Köpek seçilince: bütün alanlar ve sonuç temizlenir → yalnız ürün tablosundaki tanım kimliğiyle aynı kayıtlı ölçüler
       yazılır → tek kez hesaplanır. İki köpeğin ölçüsü aynı formda birleşmez; "elle gireceğim" alanları boşaltır.
       Okunamayan ya da bilinmeyen sürümlü kayıtta seçim gösterilmez, bulucu elle girişle çalışır. */
    const kopekAlani = panel.querySelector('[data-bn-bulucu-kopek]');
    if (!kopekAlani) return;
    let kayit, urunler, kmetin;
    try {
      kayit = JSON.parse(panel.querySelector('[data-bn-bulucu-kopekler]').textContent);
      urunler = JSON.parse(panel.querySelector('[data-bn-bulucu-urunler]').textContent).map(String);
      kmetin = JSON.parse(panel.querySelector('[data-bn-bulucu-kopek-metin]').textContent);
    } catch (e) { return; }
    if (!kayit || kayit.surum !== 1 || !Array.isArray(kayit.kopekler)) return;
    const kopekler = kayit.kopekler.filter(k => k && typeof k.id === 'string' && typeof k.ad === 'string');
    if (!kopekler.length) return;
    const ozet = Array.isArray(kayit.ozet) ? kayit.ozet : [];
    const secim = kopekAlani.querySelector('[data-bn-bulucu-kimin]');
    const not = kopekAlani.querySelector('[data-bn-bulucu-kopek-not]');
    kopekler.forEach(k => {
      const o = document.createElement('option');
      o.value = k.id; o.textContent = k.ad;
      secim.append(o);
    });
    kopekAlani.hidden = false;
    const ESKI = 183 * 86400000;
    const urunNo = gid => String(gid || '').split('/').pop();

    const kopekSec = id => {
      girdiler.forEach(g => { g.value = ''; });
      temizle();
      not.textContent = '';
      const k = kopekler.find(x => x.id === id);
      if (!k) return;
      const olculer = k.olculer && typeof k.olculer === 'object' ? k.olculer : {};
      const eksik = [];
      let enEski = null;
      tablo.olculer.forEach(m => {
        const g = girdiler.find(x => x.dataset.bnBulucuGirdi === m.kod);
        const o = m.tanim ? olculer[m.tanim] : null;
        if (g && o && typeof o.deger === 'number' && o.deger > 0) {
          g.value = sayi(o.deger);
          if (o.tarih && (!enEski || o.tarih < enEski)) enEski = o.tarih;
        } else eksik.push(m.ad.toLocaleLowerCase(dil));
      });
      const notlar = [];
      if (eksik.length) notlar.push(kmetin.eksik.replace('%AD%', k.ad).replace('%OLCULER%', bagla(eksik)));
      if (enEski && Date.now() - new Date(enEski).getTime() > ESKI) notlar.push(kmetin.eski.replace('%AD%', k.ad));
      const alinan = ozet.filter(x => x && x.kopek === k.id && urunler.includes(urunNo(x.urun)))
        .sort((a, b) => String(b.tarih).localeCompare(String(a.tarih)))[0];
      if (alinan) notlar.push(kmetin.alinan.replace('%AD%', k.ad).replace('%BEDEN%', kisa(stok(), alinan.beden)));
      not.textContent = notlar.join(' ');
      hesapla();
    };
    secim.addEventListener('change', () => kopekSec(secim.value));

    // İlk seçim: adresteki ?kopek= yalnız bu müşterinin listesinde varsa; yoksa tek köpekte o köpek.
    let ilk = '';
    try { ilk = new URLSearchParams(location.search).get('kopek') || ''; } catch (e) { ilk = ''; }
    const adrestenGeldi = kopekler.some(k => k.id === ilk);
    if (!adrestenGeldi) ilk = kopekler.length === 1 ? kopekler[0].id : '';
    if (ilk) {
      secim.value = ilk;
      kopekSec(ilk);
      if (adrestenGeldi && panel.hidden) { panel.hidden = false; ac.setAttribute('aria-expanded', 'true'); }
    }
  };

  /* Ölçü tablosu penceresi (B.2; plan §6): [data-bn-tablo-ac] bağlantıları sayfadaki <dialog data-bn-tablo>'yu açar;
     Esc, "Kapat" ve arka plana tıklama kapatır, odak açan bağlantıya döner. Pencere yoksa bağlantı görselin kendisine gider. */
  const tabloBagla = sayfa => {
    const pencere = sayfa.querySelector('dialog[data-bn-tablo]');
    if (!pencere || pencere.dataset.bnBagli || typeof pencere.showModal !== 'function') return;
    pencere.dataset.bnBagli = '1';
    const kapat = pencere.querySelector('[data-bn-tablo-kapat]');
    let acan = null;
    sayfa.addEventListener('click', e => {
      const a = e.target.closest('[data-bn-tablo-ac]');
      if (!a) return;
      e.preventDefault();
      acan = a;
      pencere.showModal();
      kapat.focus();
    });
    kapat.addEventListener('click', () => pencere.close());
    pencere.addEventListener('click', e => { // arka plan: pencere kutusunun dışına tıklama
      if (e.target !== pencere) return;
      const k = pencere.getBoundingClientRect();
      if (e.clientX < k.left || e.clientX > k.right || e.clientY < k.top || e.clientY > k.bottom) pencere.close();
    });
    pencere.addEventListener('close', () => { if (acan) acan.focus(); acan = null; });
  };

  const hepsi = () => document.querySelectorAll('.bn-pdp[data-js-product-component]').forEach(s => { baglan(s); bulucuBagla(s); tabloBagla(s); });
  window.BunicoPdp = { baglan, bicim, bedenOner, olcuOku };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  // Tema editörü: section yeniden yüklenince yeniden bağlan.
  document.addEventListener('shopify:section:load', hepsi);
})();
